<section class="virtual-scroll-wrapper--sticky">
 <ng-content [select]="ogsSticky"/>
</section>
<cdk-virtual-scroll-viewport class="virtual-scroll-wrapper--scroll" [itemSize]="itemSize()" [minBufferPx]="minBufferPx()" [maxBufferPx]="maxBufferPx()">
	<ng-container *cdkVirtualFor="let item of scrollItems()" [ngTemplateOutlet]="item"/>
</cdk-virtual-scroll-viewport>